<agpr-take-over-panel
    [header]="title"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="updateHeader()"
    (finishedOpen)="panelOpened()"
    [responsiveWidth]="true"
    [minPanelWidth]="minPanelWidth"
    [maxPanelWidth]="maxPanelWidth"
>
    <div class="agpr-aiDistributionHeader-bodyWrapper">
        <agpr-scroll-panel>
            <div class="agpr-aiDistributionHeader-container">
                <!-- Left Side -->
                <div
                    [agprLoading]="!doneSettingBodyText"
                    class="agpr-aiDistributionHeader-fields"
                >
                    <div class="agpr-aiDistributionHeader-required-label">
                        <span class="agpr-requiredAsterix"> * </span>
                        {{ 'Discover.targeting.distribution.headerEditor.required' | localize }}
                    </div>

                    <!-- Subject Line -->
                    <div class="agpr-aiDistributionHeader-inputRow">
                        <div
                            class="agpr-aiDistributionHeader-inputsWithMergeTag"
                            [class.agpr-aiDistributionHeader-inputs]="openAiPermission"
                        >
                            <agpr-text-input #subjectLineInput
                                placeholder="Discover.targeting.distribution.headerEditor.subjectLine.placeholder"
                                [(ngModel)]="subjectLine"
                                label="Discover.targeting.distribution.headerEditor.subjectLine"
                                tooltip="Discover.targeting.distribution.headerEditor.subjectLine.tooltip"
                                [required]="true"
                                [id]="'aiDistributionHeader.subjectLineInput'"
                                (keyup)="subjectLineKeyUp($event)"
                                (focus)="showInfo(infoTypes.subjectLine)"
                                (blur)="validateSubjectLine($event)"
                                [maxLength]="255"
                                [icon]="subjectLine && subjectLine.length > 0 ? (assessmentMessages.subjectLine.length > 0 ? 'fa-solid fa-circle-exclamation' : 'fa-solid fa-circle-check') : null"
                                [iconPopoverTemplate]="subjectLine && subjectLine.length > 0 ? (assessmentMessages.subjectLine.length > 0 ? subjectLinePopover : null) : null"
                                [iconPopoverStyleClass]="'agpr-aiDistributionHeader-hintsPopover'"
                                [iconPopoverText]="assessmentMessages.subjectLine.toString()"
                                [tooltipLarge]="true"
                            ></agpr-text-input>
                        </div>
                        <agpr-icon-dropdown
                            class="agpr-aiDistributionHeader-mergeTagDropdown"
                            displayIcon="fa-regular fa-duotone fa-user-tag"
                            [options]="mergeTagOptions"
                            [customOptions]="mergeTagCustomOptions"
                            [keepSelectedValue]="false"
                            agprTooltip="Common.forms.richText.mergeTags"
                            ariaLabel="Common.forms.richText.mergeTags"
                            (change)="addMergeTagToInput($event.value, infoTypes.subjectLine)"
                        ></agpr-icon-dropdown>
                        <div
                            *ngIf="openAiPermission"
                            class="agpr-aiDistributionHeader-aiButtons"
                        >
                            <agpr-button
                                [id]="'agpr_aiDistributionHeader_generateSubjectLine'"
                                class="agpr-aiDistributionHeader-plainButton"
                                [style]="buttonTypes.icon"
                                [icon]="'fa-kit-duotone fa-agpr-ai'"
                                [tooltip]="noBodyText ? 'Common.dialog.aiDistributionHeader.noBodyTextSL' : 'Common.dialog.aiDistributionHeader.generateSubjectLine'"
                                tooltipPosition="top"
                                ariaLabel="Common.dialog.aiDistributionHeader.generateSubjectLine"
                                [disabled]="subjectLinePromptsLoading || previewTextPromptsLoading || noBodyText"
                                (click)="generateSubjectLine()"
                            ></agpr-button>
                        </div>
                    </div>
                    <div
                        [@panelState]="(subjectLinePrompts?.length || subjectLinePromptsLoading) && showSubjectLinePrompts ? 'visible' : 'hidden'"
                        class="agpr-aiDistributionHeader-suggestions-container"
                        [class.agpr-aiDistributionHeader-suggestions-container-loading]="subjectLinePromptsLoading"
                        [class.agpr-aiDistributionHeader-suggestions-container-finished]="!subjectLinePromptsLoading"
                        (focusout)="dismissPromptsByFocus($event)"
                    >
                        <div
                            *ngIf="showSubjectLinePrompts"
                            class="agpr-aiDistributionHeader-suggestions-content"
                        >
                            <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
                            <ul [attr.aria-label]="'Common.dialog.aiDistributionHeader.subjectLineOptionsList' | localize">
                                <li
                                    *ngFor="let suggestion of subjectLinePrompts; let i = index"
                                    tabindex="0"
                                    class="agpr-aiDistributionHeader-suggestions-item"
                                    [class.agpr-aiDistributionHeader-suggestions-item-selected]="subjectLineSelected === i"
                                    (keyup.enter)="setSubjectLine(suggestion)"
                                    (click)="setSubjectLine(suggestion)"
                                >
                                    <span class="agpr-aiDistributionHeader-suggestions-item-text">{{suggestion | localize}}</span>
                                </li>
                                <li
                                    *ngIf="subjectLinePromptsLoading"
                                    id="agpr_aiDistributionHeader_subjectLineLoading"
                                    class="agpr-aiDistributionHeader-suggestions-item agpr-aiDistributionHeader-suggestions-item-loading"
                                    [agprLoading]="true"
                                    [agprInlineLoadingIndicator]="true"
                                    [loadingSmallIndicator]="true"
                                    (click)="doNotCloseSubjectLine($event)"
                                >
                                </li>
                            </ul>
                            <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
                        </div>
                    </div>
                    <ng-template #subjectLinePopover>
                        <div class="agpr-aiDistributionHeader-fields-assessment-popover">
                            <span class="agpr-aiDistributionHeader-fields-assessment-popover-icon agpr-message-icon fa-regular fa-circle-info"></span>
                            <div class="agpr-aiDistributionHeader-fields-assessment-popover-content">
                                <p
                                    *ngFor="let message of assessmentMessages.subjectLine"
                                    class="agpr-aiDistributionHeader-fields-assessment-popover-content-message"
                                >
                                    {{ message }}
                                </p>
                            </div>
                        </div>
                    </ng-template>
                    <span #subjectLineLiveRegion class="sr-only" role="region" aria-live="polite"></span>
                    <agpr-form-message *ngIf="subjectLineError">
                        {{ 'Discover.targeting.distribution.header.errors.hasNoSubjectLine' | localize }}
                    </agpr-form-message>
                    <agpr-form-message
                        *ngIf="subjectLineAiError"
                        [class.agpr-aiDistributionHeader-subjectLineError]="subjectLineError && subjectLineAiError"
                    >
                        {{ 'Common.dialog.aiDistributionHeader.subjectLineError' | localize }}
                    </agpr-form-message>

                    <!-- Prehead text -->
                    <div class="agpr-aiDistributionHeader-inputRow">
                        <div
                            class="agpr-aiDistributionHeader-inputsWithMergeTag"
                            [class.agpr-aiDistributionHeader-inputs]="openAiPermission"
                        >
                            <agpr-text-input #previewTextInput
                                placeholder="Discover.targeting.distribution.headerEditor.previewText.placeholder"
                                label="Discover.targeting.distribution.headerEditor.previewText"
                                tooltip="Discover.targeting.distribution.headerEditor.previewText.tooltip"
                                [(ngModel)]="previewText"
                                [id]="'aiDistributionHeader.previewTextInput'"
                                (keyup)="previewTextKeyUp($event)"
                                (focus)="showInfo(infoTypes.previewText)"
                                (blur)="validatePreviewText($event)"
                                [maxLength]="90"
                                [icon]="(assessmentMessages && assessmentMessages.previewText.length > 0) ? 'fa-solid fa-circle-exclamation' : 'fa-solid fa-circle-check'"
                                [iconPopoverTemplate]="(assessmentMessages && assessmentMessages.previewText.length > 0) ? previewTextPopover : null"
                                [iconPopoverStyleClass]="'agpr-aiDistributionHeader-hintsPopover'"
                                [iconPopoverText]="assessmentMessages.previewText.toString()"
                                [tooltipLarge]="true"
                            >
                            </agpr-text-input>
                        </div>
                        <agpr-icon-dropdown
                            class="agpr-aiDistributionHeader-mergeTagDropdown"
                            displayIcon="fa-regular fa-duotone fa-user-tag"
                            [options]="mergeTagOptions"
                            [customOptions]="mergeTagCustomOptions"
                            [keepSelectedValue]="false"
                            inputTooltip="Common.forms.richText.mergeTags"
                            ariaLabel="Common.forms.richText.mergeTags"
                            (change)="addMergeTagToInput($event.value, infoTypes.previewText)"
                        ></agpr-icon-dropdown>
                        <div
                            *ngIf="openAiPermission"
                            class="agpr-aiDistributionHeader-aiButtons"
                        >
                            <agpr-button
                                [id]="'agpr_aiDistributionHeader_generatePreviewText'"
                                class="agpr-aiDistributionHeader-plainButton"
                                [style]="buttonTypes.icon"
                                [icon]="'fa-kit-duotone fa-agpr-ai'"
                                [tooltip]="noBodyText ? 'Common.dialog.aiDistributionHeader.noBodyTextPT' : 'Common.dialog.aiDistributionHeader.generatePreviewText'"
                                tooltipPosition="top"
                                ariaLabel="Common.dialog.aiDistributionHeader.generatePreviewText"
                                [disabled]="previewTextPromptsLoading || subjectLinePromptsLoading || noBodyText"
                                (click)="generatePreviewText()"
                            ></agpr-button>
                        </div>
                    </div>
                    <div
                        [@panelState]="(previewTextPrompts?.length || previewTextPromptsLoading) && showPreviewTextPrompts ? 'visible' : 'hidden'"
                        [class.agpr-aiDistributionHeader-suggestions-container-loading]="previewTextPromptsLoading"
                        [class.agpr-aiDistributionHeader-suggestions-container-finished]="!previewTextPromptsLoading"
                        class="agpr-aiDistributionHeader-suggestions-container"
                        (focusout)="dismissPromptsByFocus($event)"
                    >
                        <div
                            *ngIf="showPreviewTextPrompts"
                            class="agpr-aiDistributionHeader-suggestions-content"
                        >
                            <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
                            <ul [attr.aria-label]="'Common.dialog.aiDistributionHeader.previewTextOptionsList' | localize">
                                <li
                                    *ngFor="let suggestion of previewTextPrompts; let i = index"
                                    tabindex="0"
                                    class="agpr-aiDistributionHeader-suggestions-item"
                                    [class.agpr-aiDistributionHeader-suggestions-item-selected]="previewTextSelected === i"
                                    (keyup.enter)="setPreviewText(suggestion)"
                                    (click)="setPreviewText(suggestion)"
                                >
                                    <span class="agpr-aiDistributionHeader-suggestions-item-text">{{suggestion | localize}}</span>
                                </li>
                                <li
                                    *ngIf="previewTextPromptsLoading"
                                    id="agpr_aiDistributionHeader_previewTextLoading"
                                    class="agpr-aiDistributionHeader-suggestions-item agpr-aiDistributionHeader-suggestions-item-loading"
                                    [agprLoading]="true"
                                    [agprInlineLoadingIndicator]="true"
                                    [loadingSmallIndicator]="true"
                                    (click)="doNotClosePreviewText($event)"
                                >
                                </li>
                            </ul>
                            <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
                        </div>
                    </div>
                    <ng-template #previewTextPopover>
                        <div class="agpr-aiDistributionHeader-fields-assessment-popover">
                            <span class="agpr-aiDistributionHeader-fields-assessment-popover-icon agpr-message-icon fa-regular fa-circle-info"></span>
                            <div class="agpr-aiDistributionHeader-fields-assessment-popover-content">
                                <p
                                    *ngFor="let message of assessmentMessages.previewText"
                                    class="agpr-aiDistributionHeader-fields-assessment-popover-content-message"
                                >
                                    {{ message }}
                                </p>
                            </div>
                        </div>
                    </ng-template>
                    <span #previewTextLiveRegion role="region" class="sr-only" aria-live="polite"></span>
                    <agpr-form-message *ngIf="previewTextAiError">
                        {{ 'Common.dialog.aiDistributionHeader.previewTextError' | localize }}
                    </agpr-form-message>

                    <!-- Send from -->
                    @if(dataConnectionService.hasEmailAccountProvision$ | async) {
                        <div
                            [class.agpr-aiDistributionHeader-inputs]="openAiPermission"
                        >
                            <div class="agpr-aiDistributionHeader-title">
                                {{ "Discover.targeting.distribution.headerEditor.sendFrom" | localize }}
                            </div>
                            <agpr-dropdown
                                [id]="'aiDistributionHeader_sendFromDropdown'"
                                class="agpr-aiDistributionHeader-sendFrom"
                                [options]="emailAccountOptions"
                                [(ngModel)]="selectedDefaultEmailAccount"
                                (ngModelChange)="setSendFrom()"
                                [callToAction]="sendFromCallToAction"
                                (focus)="showInfo(infoTypes.sendFrom)"
                                [itemTemplate]="itemTemplate"
                                panelStyleClass="agpr-aiDistributionHeader-sendFromItem-panel"
                            >
                                <ng-template let-item #itemTemplate>
                                    @if(item) {
                                        <div class="agpr-aiDistributionHeader-sendFromItem agpr-aiDistributionHeader-sendFromItem-panelPadding">
                                            <span class="agpr-aiDistributionHeader-sendFromItem-label">{{item.label}}</span>
                                            <span class="agpr-aiDistributionHeader-sendFromItem-spacer"></span>
                                            <span class="agpr-aiDistributionHeader-sendFromItem-subLabel">{{item.subLabel}}</span>
                                            @if (item.value?.grant?.requiresReAuthentication) {
                                                <span
                                                    class="agpr-aiDistributionHeader-sendFromItem-popover fa-solid agpr-aiDistributionHeader-sendFromItem-popover--error agpr-aiDistributionHeader-sendFromItem-popover--display fa-minus-circle"
                                                    role="img"
                                                    [agprPopover]="invalidGrantPopover"
                                                    [popoverZIndex]="++zIndex"
                                                    [popoverStyleClass]="'agpr-aiDistributionHeader-hintsPopover'"
                                                ></span>
                                                <ng-template #invalidGrantPopover>
                                                    <div class="agpr-aiDistributionHeader-fields-assessment-popover agpr-aiDistributionHeader-fields-assessment-popover--error">
                                                        <span class="agpr-aiDistributionHeader-fields-assessment-popover-icon agpr-message-icon fa-regular fa-minus-circle"></span>
                                                        <div
                                                            class="agpr-aiDistributionHeader-fields-assessment-popover-content"
                                                        >
                                                            <p>{{'Common.dialog.aiDistributionHeader.sendFrom.popover.reauth.header' | localize}}</p>
                                                            <p>{{'Common.dialog.aiDistributionHeader.sendFrom.popover.reauth.text' | localize}}</p>
                                                            <agpr-button
                                                                [id]="'agpr_aiDistributionHeader_sendFrom_reauth'"
                                                                [label]="'Common.dialog.aiDistributionHeader.sendFrom.popover.reauth.link'"
                                                                [style]="buttonTypes.link"
                                                                (click)="openDataConnectionsWindow()"
                                                                [uppercase]="false"
                                                                [underline]="true"
                                                            ></agpr-button>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            } @else if(item.subLabel) {
                                                <span
                                                    class="agpr-aiDistributionHeader-sendFromItem-popover fa-solid fa-circle-exclamation"
                                                    role="img"
                                                    [agprPopover]="sendFromPopover"
                                                    [popoverZIndex]="++zIndex"
                                                    [popoverStyleClass]="'agpr-aiDistributionHeader-hintsPopover'"
                                                ></span>
                                                <ng-template #sendFromPopover>
                                                    <div class="agpr-aiDistributionHeader-fields-assessment-popover">
                                                        <span class="agpr-aiDistributionHeader-fields-assessment-popover-icon agpr-message-icon fa-regular fa-circle-info"></span>
                                                        <div
                                                            class="agpr-aiDistributionHeader-fields-assessment-popover-content"
                                                        >
                                                            <span>{{'Common.dialog.aiDistributionHeader.sendFrom.popover.text' | localize}}</span>
                                                            <ul class="agpr-aiDistributionHeader-fields-assessment-popover-list">
                                                                <li>{{'Common.dialog.aiDistributionHeader.sendFrom.popover.point1' | localize}}</li>
                                                                <li>{{'Common.dialog.aiDistributionHeader.sendFrom.popover.point2' | localize}}</li>
                                                                <li>{{'Common.dialog.aiDistributionHeader.sendFrom.popover.point3' | localize}}</li>
                                                                <li>{{'Common.dialog.aiDistributionHeader.sendFrom.popover.point4' | localize}}</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            }
                                        </div>
                                    }
                                </ng-template>
                            </agpr-dropdown>
                        </div>
                    }

                    <!-- From Name -->
                    <div
                        [class.agpr-aiDistributionHeader-inputs]="openAiPermission"
                    >
                        <agpr-text-input #fromNameInput
                            placeholder="Discover.targeting.distribution.headerEditor.fromName.placeholder"
                            label="Discover.targeting.distribution.headerEditor.fromName"
                            tooltip="Discover.targeting.distribution.headerEditor.fromName.tooltip"
                            [required]="true"
                            [(ngModel)]="fromName"
                            [id]="'aiDistributionHeader.fromNameInput'"
                            (keyup)="fromNameKeyUp($event)"
                            (focus)="showInfo(infoTypes.fromName)"
                            (blur)="validateFromName()"
                            [maxLength]="100"
                            [icon]="fromName && fromName.length > 0 ? (assessmentMessages.fromName.length > 0 ? 'fa-solid fa-circle-exclamation' : 'fa-solid fa-circle-check') : null"
                            [iconPopoverTemplate]="fromName && fromName.length > 0 ? (assessmentMessages.fromName.length > 0 ? fromNamePopover : null) : null"
                            [iconPopoverStyleClass]="'agpr-aiDistributionHeader-hintsPopover'"
                            [iconPopoverText]="assessmentMessages.fromName.toString()"
                            [tooltipLarge]="true"
                        >
                        </agpr-text-input>
                    </div>
                    <ng-template #fromNamePopover>
                        <div class="agpr-aiDistributionHeader-fields-assessment-popover">
                            <span class="agpr-aiDistributionHeader-fields-assessment-popover-icon agpr-message-icon fa-regular fa-circle-info"></span>
                            <div class="agpr-aiDistributionHeader-fields-assessment-popover-content">
                                <p
                                    *ngFor="let message of assessmentMessages.fromName"
                                    class="agpr-aiDistributionHeader-fields-assessment-popover-content-message"
                                >
                                    {{ message }}
                                </p>
                            </div>
                        </div>
                    </ng-template>
                    <span #fromNameLiveRegion class="sr-only" role="region" aria-live="polite"></span>
                    <agpr-form-message *ngIf="fromNameError">
                        {{ 'Discover.targeting.distribution.header.errors.hasNoFrom' | localize }}
                    </agpr-form-message>

                    <!-- Reply-to -->
                    <div
                        [class.agpr-aiDistributionHeader-inputs]="openAiPermission"
                    >
                        <agpr-text-input #replyEmailInput
                            placeholder="Discover.targeting.distribution.headerEditor.replyEmail.placeholder"
                            label="Discover.targeting.distribution.headerEditor.replyEmail"
                            tooltip="Discover.targeting.distribution.headerEditor.replyEmail.tooltip"
                            [required]="true"
                            [(ngModel)]="replyEmail"
                            [id]="'aiDistributionHeader.replyEmailInput'"
                            (keyup)="replyEmailKeyUp($event)"
                            (focus)="showInfo(infoTypes.replyEmail)"
                            (blur)="replyEmailBlur()"
                            [maxLength]="254"
                            [icon]="emailIcon"
                            [iconPopoverTemplate]="emailIcon === 'fa-solid fa-circle-exclamation' ? replyEmailPopover : null"
                            [iconPopoverStyleClass]="'agpr-aiDistributionHeader-hintsPopover'"
                            [iconPopoverText]="assessmentMessages.replyEmail.toString()"
                            [tooltipLarge]="true"
                        >
                        </agpr-text-input>
                    </div>
                    <ng-template #replyEmailPopover>
                        <div class="agpr-aiDistributionHeader-fields-assessment-popover">
                            <span class="agpr-aiDistributionHeader-fields-assessment-popover-icon agpr-message-icon fa-regular fa-circle-info"></span>
                            <div class="agpr-aiDistributionHeader-fields-assessment-popover-content">
                                <p
                                    *ngFor="let message of assessmentMessages.replyEmail"
                                    class="agpr-aiDistributionHeader-fields-assessment-popover-content-message"
                                >
                                    {{ message }}
                                </p>
                            </div>
                        </div>
                    </ng-template>
                    <span #replyEmailLiveRegion class="sr-only" role="region" aria-live="polite"></span>
                    <agpr-form-message *ngIf="emailIcon === 'fa-solid fa-circle-xmark'">
                    {{ 'invalidEmailFormat' | localize }}
                    </agpr-form-message>
                    <agpr-form-message *ngIf="replyEmailError">
                        {{ 'Discover.targeting.distribution.header.errors.hasNoReplyEmail' | localize }}
                    </agpr-form-message>
                </div>

                <!-- Right Side -->
                <div class="agpr-aiDistributionHeader-infoPanel">
                    <div class="agpr-aiDistributionHeader-infoPanel-header">
                        <span class="agpr-aiDistributionHeader-infoPanel-header-icon agpr-i-light-bulb" aria-hidden="true"></span>
                        <div class="agpr-aiDistributionHeader-infoPanel-header-content">
                            <span class="agpr-aiDistributionHeader-infoPanel-header-content-quickTips">{{ 'Discover.targeting.distribution.headerEditor.quickTips' | localize }} - </span>
                            <span
                                *ngIf="!infoContent.label"
                                class="agpr-aiDistributionHeader-infoPanel-header-content-field"
                            >
                                {{ 'Discover.targeting.distribution.headerEditor.defaultInfoHeader' | localize }}
                            </span>
                            <span
                                *ngIf="infoContent.label"
                                class="agpr-aiDistributionHeader-infoPanel-header-content-field"
                            >
                                {{ infoContent.label | localize }}
                            </span>
                        </div>
                    </div>
                    <div
                        *ngIf="!infoContent.label"
                        class="agpr-aiDistributionHeader-infoPanel-content-placeholder"
                    >
                        <p>{{ 'Discover.targeting.distribution.headerEditor.defaultInfoContent' | localize }}</p>
                    </div>
                    @if (infoContent.description) {
                        <div class="agpr-aiDistributionHeader-infoPanel-content-description">
                            {{ infoContent.description | localize }}
                        </div>
                    }
                    <div>
                    </div>
                    <ul class="agpr-aiDistributionHeader-infoPanel-content-list">
                        <li *ngFor="let hint of infoContent.hints">{{ hint | localize }}</li>
                    </ul>
                    <div
                        *ngIf="openAiPermission && aiQuickTipInfo"
                        class="agpr-aiDistributionHeader-aiQuickTip"
                    >
                        <div class="agpr-aiDistributionHeader-aiQuickTip-content">
                            <div
                                class="agpr-aiDistributionHeader-aiQuickTip-heading"
                                [innerHTML]="('Common.dialog.aiDistributionHeader.quickTip.heading' | localize) | sanitizeHtml"
                            ></div>
                            <div class="agpr-aiDistributionHeader-aiQuickTip-body">
                                <span class="agpr-aiDistributionHeader-aiQuickTip-body-icon fa-kit-duotone fa-agpr-ai"></span> {{ aiQuickTipInfo | localize }}
                            </div>
                        </div>
                    </div>
                    @if (infoContent.callToActionLink) {
                        <agpr-button
                            [id]="'agpr_aiDistributionHeader_infoPanel_callToActionButton'"
                            [label]="infoContent.callToActionLink"
                            [style]="buttonTypes.link"
                            (click)="rhpCallToAction(infoContent.infoType)"
                            [uppercase]="false"
                            [underline]="true"
                        ></agpr-button>
                    }
                </div>
            </div>
        </agpr-scroll-panel>
    </div>
    <!-- footer -->
    <ng-template #takeOverFooterLeft>
        <agpr-button
            [id]="'agpr_aiDistributionHeader_cancel'"
            label="Core.button.cancel"
            [style]="buttonTypes.secondary"
            (click)="updateHeader()"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        <agpr-button
            [id]="'agpr_aiDistributionHeader_update'"
            label="done"
            [style]="buttonTypes.primary"
            (click)="updateHeader()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
